import { z } from "zod";

// Generic, extensible analytics event mechanism. Events are stored in the
// `analytics_events` table (one row per event), linked to an analytics session
// (orchestrators_analytics). Add new event types here as the product grows so
// every event keeps a single, type-safe source of truth.
export enum AnalyticsEventType {
  // Fired once per session when the satisfaction survey is displayed to the end user.
  SurveyDisplayed = "survey_displayed",
}

export const analyticsEventTypeSchema = z.nativeEnum(AnalyticsEventType);

// Properties is an opaque JSON bag whose exact shape depends on the event type
// (e.g. survey_displayed carries the satisfaction form identifier).
export const analyticsEventPropertiesSchema = z.record(z.string(), z.unknown());

export const APITrackEventSchema = z.object({
  analyticId: z.string().uuid(),
  eventType: analyticsEventTypeSchema,
  properties: analyticsEventPropertiesSchema.optional(),
});

export const APIGetSessionEventTypesSchema = z.object({
  analyticId: z.string().uuid(),
});

export type AnalyticsEventProperties = z.infer<typeof analyticsEventPropertiesSchema>;
export type APITrackEvent = z.infer<typeof APITrackEventSchema>;
export type APIGetSessionEventTypes = z.infer<typeof APIGetSessionEventTypesSchema>;
